export default __webpack_public_path__ + "static/media/loginTheme.fabab0b4.png";